import styled from 'styled-components';
import { appConfig } from '../../../../configureApp';

const TrawickLoginTop = styled.div`
    background: #031c30;
    padding: 15px 65px 5px;
    border-radius: 10px 10px 0px 0px;
    text-align: center;
    color: #eff0f3;
`;

const SCTILoginTop = styled.div`
    background: #F7F7F7;
    padding: 15px 65px 5px;
    border-radius: 10px 10px 0px 0px;
    text-align: center;
    color: #4A4A4A;
    font-family: 'Omnes';
    font-size: 24px;
    font-weight: 600; /* Semibold */
`;

const LoginTop = appConfig.reactAppEnv === 'scti'  || appConfig.reactAppEnv === 'tugo' ? SCTILoginTop : TrawickLoginTop;

export default LoginTop;



// WEBPACK FOOTER //
// ./app/containers/Login/components/LoginTop/index.js